import { __extends } from "tslib";
import { AbstractionBase, AbstractMethodError } from '@awayjs/core';
/**
 * @class RenderableListItem
 */
var _Pick_PickableBase = /** @class */ (function (_super) {
    __extends(_Pick_PickableBase, _super);
    function _Pick_PickableBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(_Pick_PickableBase.prototype, "entity", {
        get: function () {
            return this._useWeak ? this._pool.deref() : this._pool;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param renderable
     * @param sourceEntity
     * @param surface
     * @param renderer
     */
    _Pick_PickableBase.prototype.init = function (traversable, entity) {
        _super.prototype.init.call(this, traversable, entity, true);
        entity.addPickable(this);
    };
    _Pick_PickableBase.prototype.onClear = function (event) {
        var _a;
        (_a = this.entity) === null || _a === void 0 ? void 0 : _a.removePickable(this);
        _super.prototype.onClear.call(this, event);
    };
    _Pick_PickableBase.prototype.hitTestPoint = function (x, y, z) {
        throw new AbstractMethodError();
    };
    _Pick_PickableBase.prototype.getBoxBounds = function (matrix3D, strokeFlag, cache, target) {
        if (matrix3D === void 0) { matrix3D = null; }
        if (strokeFlag === void 0) { strokeFlag = true; }
        if (cache === void 0) { cache = null; }
        if (target === void 0) { target = null; }
        return target;
    };
    _Pick_PickableBase.prototype.getSphereBounds = function (center, matrix3D, strokeFlag, cache, target) {
        if (matrix3D === void 0) { matrix3D = null; }
        if (strokeFlag === void 0) { strokeFlag = true; }
        if (cache === void 0) { cache = null; }
        if (target === void 0) { target = null; }
        return target;
    };
    _Pick_PickableBase.prototype.testCollision = function (collision, closestFlag) {
        throw new AbstractMethodError();
    };
    return _Pick_PickableBase;
}(AbstractionBase));
export { _Pick_PickableBase };
